import { Globe } from "lucide-react";

import { SourceBadge } from "@/components/people/source-badge";
import type { PersonDetail } from "@/api/db/people";
import { PessoaLabels } from "@/lib/labels";

import { SideBlock } from "./ficha-sections";

export function FichaProvenance({ person }: { person: PersonDetail }) {
	const sources = Array.from(new Set(person.sources.map((source) => source.source)));

	if (sources.length === 0) {
		return null;
	}

	return (
		<SideBlock icon={<Globe className="size-4" />} title={PessoaLabels.side.provenance}>
			<div className="flex flex-wrap items-center gap-2">
				<span className="text-sm text-muted-foreground">{PessoaLabels.provenanceFrom}</span>

				{sources.map((source) => (
					<SourceBadge key={source} source={source} />
				))}
			</div>
		</SideBlock>
	);
}
